import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'src/components/shared/Button/Button';
import { DescriptionList } from 'src/components/shared/DescriptionList/DescriptionList';
import { Header4 } from 'src/components/shared/Typography/Header4';
import { ProductDetailDto } from 'src/store/products/product';
import { formatDateTime } from 'src/utils/date';

type Props = {
  product: Nullable<ProductDetailDto>;
  onCreateNorlabNo: (id: number) => void;
};

export const Norlab: React.FC<Props> = ({ product, onCreateNorlabNo }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <DescriptionList className="mb-24">
        <li>
          <Header4>{t('product.norlabNo')}</Header4>
          {product?.norlabNo || '-'}
        </li>
        <li>
          <Header4>{t('product.norlabDate')}</Header4>
          {formatDateTime(product?.norlabDate) || '-'}
        </li>
      </DescriptionList>

      <PrimaryButton
        disabled={!product?.id || !!product?.norlabNo}
        onClick={() => {
          onCreateNorlabNo(product!.id);
        }}
      >
        {t('product.generateNorlab')}
      </PrimaryButton>
    </Fragment>
  );
};
